import React from 'react'
import Wrapper from '../Wrapper'


const Company = (props) => {
  return (
    <Wrapper>
    <p>Towards the end of 1994, we were tired of green-screen programming and looking for alternative ways to
    provide first class applications in about one-quarter the time of traditional methods.  Looking at all the
    available platforms and systems of the time, we recognized immediately that the 'upstart' internet had all the
    necessary underpinnings to become not just a poster gallery or a multi-site library, but
    the interactive application platform of the future.
    </p>
    <p>
    Since that time, we've been devoted to aquiring the skills to leverage the available technology
    and the knowledge to create a methodology that delivers success, resulting in some great web applications.
    We've been extremely fortunate to work with world-class clients:
    </p>
    <ul>
    <li>Smartmoney magazine</li>
    <li>Toys 'r' us</li>
    <li>Cushman and Wakefield</li>
    <li>The Princeton Review</li>
    <li>andante.com</li>
    <li>onfolio.com</li>
    <li>eSurg.com</li>
    <li>Gtriad Development Corporation</li>
    </ul>
    <p>
    Although the dot-com boom is over, the internet remains the best platform to interconnect
    multiple various devices with the web services that can provide a high return on investment.
    Highly-tuned, well-crafted applications and services can provide immediate value today
    and well into the future.
    </p>
    <p>
    <span style={{ textDecoration: 'underline' }}>Contact us:</span><br/>
    Cog Data Systems, llc<br/>
    304 West 75 Street<br/>
    New York, NY 10023<br/>
    <br/>
    voice: 212.362.6362<br/>
    email: <a href="mailto:sales@cogdata.com">sales@cogdata.com</a>
    </p>
    </Wrapper>
 )
}

export default Company



// WEBPACK FOOTER //
// ./src/components/pages/Company.js